import { Col, Row } from "antd";
import { useFormik } from "formik";
import { get, isEmpty } from "lodash";
import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";
import { ATTACHMENT_TYPES } from "utils/constants";
import { downloadUploadedDocument } from "utils/helpers/files";
import ActionButtons from "../Components/ActionButtons";
import Header from "../Components/Header";
import Layout from "../Components/Layout";
import DocumentUpload from "./DocumentUpload";
import validation from "./validation";

function View({
  initialValues,
  onSubmit,
  downloadFile,
  onBack,
  supportingDocuments,
  isRia,
  isOtherPayer,
  onFileRemove: handleFileRemove,
}) {
  const isTax = supportingDocuments.includes(ATTACHMENT_TYPES.PAY_SLIP);
  const isProfessional = supportingDocuments.includes(
    ATTACHMENT_TYPES.PROFESSIONAL_PAYMENT_ACCOUNT,
  );
  const isEnrollmentCertificate = supportingDocuments.includes(
    ATTACHMENT_TYPES.PROFESSIONAL_PAYMENT_ACCOUNT,
  );
  const { t } = useTranslation(NAME_SPACES.PUBLIC.PROCESSES);
  const { isValid, handleSubmit, setFieldValue, values, ...formProps } =
    useFormik({
      initialValues,
      enableReinitialize: true,
      onSubmit: onSubmit,
      validationSchema: validation(
        t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, {
          returnObjects: true,
        }),
        { isTax, isRia, isProfessional, isEnrollmentCertificate, isOtherPayer },
      ),
    });

  const createFileRemoveHandler = (fieldName) => async (item) => {
    if (handleFileRemove) {
      await handleFileRemove(fieldName)(item);
      const currentFiles = values[fieldName] || [];
      const updatedFiles = currentFiles.filter(
        (file) => (file?.uid || file?.id) !== (item?.uid || item?.id),
      );
      setFieldValue(fieldName, updatedFiles);
    }
  };
  const handleDownload = ({ uid, size, base64, contentType, name }) => {
    if (!size) return downloadFile(uid);
    downloadUploadedDocument({
      base64,
      contentType,
      name,
    });
  };

  return (
    <Layout>
      <Header
        title="Dernière chose ! Nous aurons besoin de vos <b>pièces justificatives</b>"
        highlight="Dernière chose !"
        subtitle="Pièces justificatives"
      />
      <Row justify="center">
        <Col xs={24} md={16} lg={14} xl={12}>
          <div className="mobilityMutual__documents--container">
            <DocumentUpload
              label={"Carte d'identité ou passeport"}
              items={values.cin}
              onDownload={handleDownload}
              onUpload={(item) => {
                setFieldValue("cin", item);
              }}
              onFileRemove={createFileRemoveHandler("cin")}
              error={get(formProps.errors, "cin")}
            />
            <DocumentUpload
              label={"Attestation Sécurité Sociale"}
              items={values.socialSecurityCertificate}
              onDownload={handleDownload}
              onUpload={(item) => {
                setFieldValue("socialSecurityCertificate", item);
              }}
              onFileRemove={createFileRemoveHandler("socialSecurityCertificate")}
              error={get(formProps.errors, "socialSecurityCertificate")}
            />
            <DocumentUpload
              label={"Relevé d’Identité Bancaire (RIB)"}
              items={values.paymentAccount}
              onDownload={handleDownload}
              onUpload={(item) => {
                setFieldValue("paymentAccount", item);
              }}
              onFileRemove={createFileRemoveHandler("paymentAccount")}
              error={get(formProps.errors, "paymentAccount")}
            />
            {/* <DocumentUpload
              label={"Mandat SEPA daté et signé"}
              items={values.signedDirectMandate}
              onDownload={handleDownload}
              onUpload={(item) => {
                setFieldValue("signedDirectMandate", item);
              }}
              onFileRemove={() => onFileRemove("signedDirectMandate")}
              error={get(formProps.errors, "signedDirectMandate")}
            /> */}
            {isProfessional && (
              <DocumentUpload
                label={"Rib Professionnel"}
                items={values.professionalPaymentAccount}
                onDownload={handleDownload}
                onUpload={(item) => {
                  setFieldValue("professionalPaymentAccount", item);
                }}
                onFileRemove={createFileRemoveHandler(
                  "professionalPaymentAccount",
                )}
                error={get(formProps.errors, "professionalPaymentAccount")}
              />
            )}
            {isTax && (
              <DocumentUpload
                label={
                  "Justificatif bulletin de salaire ou certificat employeur"
                }
                items={values.paySlip}
                onDownload={handleDownload}
                onUpload={(item) => {
                  setFieldValue("paySlip", item);
                }}
                onFileRemove={createFileRemoveHandler("paySlip")}
              />
            )}
            {isRia && (
              <DocumentUpload
                label={"Pouvoir en signature électronique"}
                items={values.electronicSignatureEligibility}
                onDownload={handleDownload}
                onUpload={(item) => {
                  setFieldValue("electronicSignatureEligibility", item);
                }}
                onFileRemove={createFileRemoveHandler(
                  "electronicSignatureEligibility",
                )}
                error={get(formProps.errors, "electronicSignatureEligibility")}
              />
            )}
            {isOtherPayer && (
              <DocumentUpload
                label={"RIB du tiers payeur"}
                items={values.payerRib}
                onDownload={handleDownload}
                onUpload={(item) => {
                  setFieldValue("payerRib", item);
                }}
                onFileRemove={createFileRemoveHandler("payerRib")}
                error={get(formProps.errors, "payerRib")}
              />
            )}
            <div className="recap__wrapper--info">
              <p>Formats de fichiers pris en charge : JPEG, PNG ou PDF</p>
              <p>Taille maximale : 5 Mo</p>
            </div>
          </div>
        </Col>
      </Row>
      <ActionButtons
        disabled={!isEmpty(formProps.errors) || isEmpty(values, "cin")}
        onNext={handleSubmit}
        buttonText="Continuer"
        onBack={onBack}
      />
    </Layout>
  );
}

export default View;
